import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublishAppComponent } from './publish-app/publish-app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModuleMobi } from '../material/material.module';
import { AppPermissionsPipe, SharedModule } from 'shared-library';



@NgModule({
  declarations: [
    PublishAppComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModuleMobi,
    SharedModule,
    AppPermissionsPipe
  ],
  exports: [
    PublishAppComponent
  ]
})
export class PublishAppModule { }
